




























import { Vue, Component } from "vue-property-decorator";
import { Utils } from "@/plugins/utils";
@Component
export default class LogDetectSetpFirst extends Vue {
  confirm = false;

  onSubmit() {
    this.$emit("submit");
  }

  onDownloadApkClick() {
    Utils.download(
      "https://sec-cdn.static.xiaomi.net/secStatic/groups/miui-sec/common/privacy/PrivacyApkTool.apk"
    );
  }
}
